export enum UserGroups {
  Admin = 'Admin',
}
